export default function HeaderTable({tamanho, children, className}) {
    return (
        <td className={` uppercase text-text-primary py-[0.625rem] text-tbody1 font-bold font-['Roboto'] flex items-center ${className}`}>{children}</td>
    )
}
